import React from 'react';
import { useFormContext } from 'react-hook-form';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { FormSelect, FormTextInput, Grid, StepControlPanel } from '@/shared/ui';
import { FormTextArea } from '@/shared/ui/TextArea/FormTextArea';
import { MultipleFormTextInput } from '@/shared/ui/TextInput/MultipleFormTextInput';

import { vehicleTypes } from '@/components/Forms/constants';

import { TransportationAndRouteDataSchema } from '../../model/types';

export const TransportationAndRouteData: React.FC<StepProps> = ({ next, prev }) => {
  const { control, watch, formState, setValue } = useFormContext<TransportationAndRouteDataSchema>();

  const intermediateRoutes = watch('transportationAndRouteData.intermediateRoute');

  return (
    <>
      <FormBlock title="Дані про транспорт">
        <FormSelect
          control={control}
          name="transportationAndRouteData.vehicleType"
          options={vehicleTypes}
          label="Вид транспорту"
          required
        />
        <FormTextInput control={control} name="transportationAndRouteData.vehicleBrand" label="Марка" />
        <FormTextInput control={control} name="transportationAndRouteData.vehicleNumber" label="Номер" />
      </FormBlock>
      <FormBlock title="Дані про маршрут">
        <FormTextInput
          control={control}
          name="transportationAndRouteData.beginningOfRoute"
          label="Початок маршруту"
          required
        />
        <MultipleFormTextInput
          value={intermediateRoutes ?? ['']}
          label="Проміжний населений пункт"
          maxTextInputsQuantity={100}
          errors={formState.errors.transportationAndRouteData?.intermediateRoute as Array<{ message: string }>}
          onChange={(texts) => {
            setValue('transportationAndRouteData.intermediateRoute', texts);
          }}
          addButtonText="Додати ще населений пункт"
        />
        <FormTextInput
          control={control}
          name="transportationAndRouteData.endOfRoute"
          label="Кінець маршруту"
          required
        />
        <FormTextArea control={control} name="transportationAndRouteData.purpose" label="Мета перевезення" required />
      </FormBlock>

      <StepControlPanel prev={prev} next={next} />
    </>
  );
};

export const TransportationAndRouteDataVehiclePreview: React.FC = () => {
  const { getValues } = useFormContext<TransportationAndRouteDataSchema>();
  const { transportationAndRouteData } = getValues();

  return (
    <Grid
      title="Дані про транспорт"
      data={[
        ['Вид транспорту', transportationAndRouteData?.vehicleType.label],
        ['Марка', transportationAndRouteData?.vehicleBrand],
        ['Номер', transportationAndRouteData?.vehicleNumber],
      ]}
    />
  );
};

export const TransportationAndRouteDataPreview: React.FC = () => {
  const { getValues } = useFormContext<TransportationAndRouteDataSchema>();
  const { transportationAndRouteData } = getValues();

  return (
    <Grid
      title="Дані про маршрут"
      data={[
        ['Початок маршруту', transportationAndRouteData?.beginningOfRoute],
        ...((transportationAndRouteData?.intermediateRoute?.map((route) => [
          'Проміжний населений пункт',
          route,
        ]) as Array<[string, string]>) ?? ([] as Array<[string, string]>)),
        ['Кінець маршруту', transportationAndRouteData?.endOfRoute],
        ['Мета перевезення', transportationAndRouteData?.purpose],
      ]}
    />
  );
};
